import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { KaizenService } from '../Services/Kaizen.Service';
import { AppComponent } from '../app.component';
import { LoaderService } from '../loader/loader.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { finalize } from 'rxjs/operators';


@Component({
    selector: 'app-cmdreview',
    templateUrl: './cmdreview.component.html',
    styleUrls: ['./cmdreview.component.css'],
    standalone: false
})
export class CmdreviewComponent implements OnInit {
  constructor(private kaizenService : KaizenService, public loaderService: LoaderService,    
              private appComponent: AppComponent, 
              private router:Router ) {     }
  kaizens: Kaizen[] = [];
  sortedKaizens: Kaizen[] = [];
  dataSource = new MatTableDataSource<Kaizen>([]);
  totalItems = 0;
  pageSize = 25;
  pageNumber = 1;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  ngOnInit(): void {
   
    const role = localStorage.getItem(`adroleNormalized`);
    if ((role != `CMDApprover`) && (role != `CMDApproverPlus`) && (role != `ISAdmin`) && (role != `SystemAdmin`)) {
      this.router.navigate([`./kaizens`]);
    }

  this.loadKaizens();
  }

  ngAfterViewInit(): void {
    this.loadKaizens();

    this.sort.sortChange.subscribe((sortState: Sort) => {
      this.applySort(sortState);
    });

    this.paginator.page.subscribe((event: PageEvent) => {
      this.pageNumber = event.pageIndex + 1;
      this.pageSize = event.pageSize;
      this.loadKaizens();
    });
  }


  loadKaizens(): void {
    this.loaderService.isLoading.next(true);

    this.kaizenService
      .getReviewKaizenPaged(false, this.appComponent.ademail, this.pageNumber, this.pageSize)
      .pipe(
        finalize(() => this.loaderService.isLoading.next(false))
      )
      .subscribe({
        next: (response) => {
          this.kaizens = response.data;
          this.totalItems = response.totalCount;
          this.sortedKaizens = [...this.kaizens];

          if (this.sort && this.sort.active && this.sort.direction) {
            this.applySort(this.sort);
          }
        },
        error: (error) => console.error(error)
      });
  }

  applySort(sortState: Sort): void {
    if (!sortState.active || sortState.direction === '') {
      this.sortedKaizens = [...this.kaizens];
      return;
    }
    const isAsc = sortState.direction === 'asc';
    this.sortedKaizens = [...this.kaizens].sort((a, b) => {
      switch (sortState.active) {
        case 'kaizenNumber':
          const numA = this.extractKaizenNumber(a.kaizenNumber);
          const numB = this.extractKaizenNumber(b.kaizenNumber);
          return this.compare(numA, numB, isAsc);
        case 'company':
          return this.compare(a.company, b.company, isAsc);
        case 'shop':
          return this.compare(a.shop, b.shop, isAsc);
        case 'name':
          return this.compare(a.name, b.name, isAsc);
        case 'account':
          return this.compare(a.account, b.account, isAsc);
        case 'fySavings':
          return this.compare(a.fySavings, b.fySavings, isAsc);
        case 'internalTrackingNo':
          return this.compare(a.internalTrackingNo, b.internalTrackingNo, isAsc);
        case 'trackingRef1':
          return this.compare(a.trackingRef1, b.trackingRef1, isAsc);
        case 'trackingRef2':
          return this.compare(a.trackingRef2, b.trackingRef2, isAsc);
        case 'state':
          return this.compare(a.state, b.state, isAsc);
        default:
          return 0;
      }
    });
  }
  private extractKaizenNumber(value: number | string): number {
    if (typeof value === 'number') {
      return value;
    }
    const numericPart = value.toString().replace(/\D/g, '');
    return Number(numericPart);
  }

  compare(a: number | string, b: number | string, isAsc: boolean): number {
    return (a < b ? -1 : a > b ? 1 : 0) * (isAsc ? 1 : -1);
  }

 OnSearch(criteria: string): void {
  if (!criteria) {
    this.kaizenService.getReviewKaizen(false, this.appComponent.ademail).subscribe(
      data => {
        this.kaizens = data.data;
        this.sortedKaizens = [...this.kaizens];
        if (this.sort && this.sort.active && this.sort.direction) {
          this.applySort(this.sort);
        }
        if (this.paginator) {
          this.paginator.firstPage();
        }
      },
      error => console.log(error)
    );
  } else {
    this.kaizenService.searchKaizens(criteria, false, '').subscribe(
      data => {
        this.kaizens = data.data;
        this.sortedKaizens = [...this.kaizens];
        if (this.sort && this.sort.active && this.sort.direction) {
          this.applySort(this.sort);
        }
        if (this.paginator) {
          this.paginator.firstPage();
        }
      },
      error => console.log(error)
    );
  }
}
    shopSizer(shopname: string): string {
      let newshopname = '';
      if (shopname.length > 15) {
        newshopname = shopname.substring(0, 15) + '...';
      }
      else {
        newshopname = shopname;
      }
      return newshopname;
    }
}
export interface Kaizen {
  kaizenId: number;
  company: number;
  shop: number;
  name: string;
  account: string;
  tags: string;
  fySavings: number;
  costMeasure: number;
  state: number;
  kaizenCreator: string;
  kaizenCreatorId: number;
  createdAt: Date;
  kaizenNumber: number;
  posted: boolean;
  version: number;
  internalTrackingNo: string;
  trackingRef1: string;
  trackingRef2: string;
}
export class PagedResponseKaizen{
 public pageNumber!: number;
 public pageSize!:number;
 public succeeded!:boolean
 public message!:string;
 public errors!:string;
 public data!:Kaizen[];
}